// src/shared/lib/scrollToTop.tsx

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' as ScrollBehavior });
  }, [pathname, search]);
  return null;
}
